/* global axios */
import ApiClient from './ApiClient';

class AgentLogs extends ApiClient {
  constructor() {
    super('agent_logs', { accountScoped: true, apiVersion: 'v3' });
  }

  getAgentLogs(params) {
    return axios.get(`${this.url}`, {
      params: {
        since: params.since,
        until: params.until,
        page: params.page,
        agent_id: params.agents,
        team_id: params.teams,
        sort: params.sort?.order_column,
        direction: params.sort?.order_direction,
        search: params.search,
      },
    });
  }
}

export default new AgentLogs();
